






import Vue from 'vue'
import { oneOf } from '@/utils/helper'

interface IData {
  processTimeout: NodeJS.Timeout | null
}

export default Vue.extend({
  props: {
    nativeType: {
      type: String,
      default: 'button'
    },
    size: {
      type: String,
      default: 'md',
      validator: oneOf(['sm', 'md'])
    },
    id: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'primary',
      validator: oneOf(['primary', 'secondary', 'tertiary'])
    },
    icon: {
      type: String,
      default: null,
      validator: oneOf(['leftArrow', 'rightArrow'])
    },
    disabled: {
      type: Boolean,
      default: false
    },
    throttle: {
      type: Number,
      default: 2000
    }
  },
  data(): IData {
    return {
      processTimeout: null
    }
  },
  computed: {
    typeClassName(): string {
      return `-${this.type}`
    },
    sizeClassName(): string {
      return `-${this.size}`
    },
    iconClassName(): string {
      return `-${this.icon}`
    }
  },
  destroyed() {
    if (this.processTimeout) clearTimeout(this.processTimeout)
  },
  methods: {
    handleClick() {
      if (this.disabled) return
      if (!this.processTimeout) {
        this.$emit('click')
        if (this.nativeType === 'submit') this.$emit('submit')
        const vm = this
        vm.processTimeout = setTimeout(() => {
          vm.processTimeout = null
        }, this.throttle)
      }
    }
  }
})
